class CustomError extends Error {
  constructor ({ message, fields }) {
    super(message);
    this.fields = fields;
    this.name = 'CustomError';
  }
}

export default CustomError;
